import { z } from 'zod';
import { principalSchema } from './user';
/** GET /api/health — unauthenticated liveness probe used by App Service. */
export const healthResponseSchema = z.object({
    status: z.literal('ok'),
    version: z.string(),
    uptimeSeconds: z.number(),
});
/** GET /api/health/ready — checks the database is reachable. */
export const readinessResponseSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    database: z.enum(['up', 'down']),
});
/** GET /api/me — the signed-in principal, or 401 when there is no session. */
export const meResponseSchema = principalSchema;
/** Shape of every error the API returns. No stack traces, no internal detail. */
export const apiErrorSchema = z.object({
    statusCode: z.number(),
    error: z.string(),
    message: z.string(),
    /** Correlation id for support. Safe to show the user. */
    traceId: z.string().optional(),
});
//# sourceMappingURL=api.js.map